// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"32":"95254c2d","485":"3745f6ac"}[chunkId] + ".js";
};